import Common from '@/utils/common'

export function searchRole(data) {
  return Common.createRequest('user-api', 'ROLE_SEARCH', data)
}

export function selectRole(data) {
  return Common.createRequest('user-api', 'ROLE_SELECT', data)
}

export function createRole(data) {
  return Common.createRequest('user-api', 'ROLE_CREATE', data)
}

export function createMerchantRole(data) {
  return Common.createRequest('user-api', 'MERCHANT_ROLE_CREATE', data)
}

export function updateRole(data) {
  return Common.createRequest('user-api', 'ROLE_UPDATE', data)
}

export function deleteRole(data) {
  return Common.createRequest('user-api', 'ROLE_DELETE', data)
}

export function platformRoleSearch(data) {
  return Common.createRequest('user-api', 'PLATFORM_ROLE_SEARCH', data)
}

export function merchantRoleSearch(data) {
  return Common.createRequest('user-api', 'MERCHANT_ROLE_SEARCH', data)
}

export function searchRolePermission(data) {
  return Common.createRequest('user-api', 'ROLE_PERMISSION_SEARCH', data)
}

export function changeRolePermission(data) {
  return Common.createRequest('user-api', 'CHANGE_ROLE_PERMISSION', data)
}